import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { SkuParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingDeliveriesSku.gridData;
export const selectDateRange = (state: RootState) => state.reportingDeliveriesSku.dateRange;



export const selectValidParams = createSelector(
	[
		selectDateRange,
	],(
		dateRange: DateRange | null,
	) => {
		if (!dateRange) return null;
		let validParams: SkuParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
		};
		return validParams;
	}
);